import { render, staticRenderFns } from "./SoundRecordingsTable.vue?vue&type=template&id=7f6d3bf7&"
import script from "./SoundRecordingsTable.vue?vue&type=script&lang=js&"
export * from "./SoundRecordingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports